export default __webpack_public_path__ + "static/media/selenium-grid-logo.86cdb73d.svg";